"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CommentAttachmentPatchDTO = void 0;
const partial_type_helper_1 = require("../../extern-libs/mapped-types/partial-type.helper");
const CommentSupplierAttachmentDTO_1 = require("./CommentSupplierAttachmentDTO");
class CommentAttachmentPatchDTO extends (0, partial_type_helper_1.PartialType)(CommentSupplierAttachmentDTO_1.CommentSupplierAttachmentDTO) {
}
exports.CommentAttachmentPatchDTO = CommentAttachmentPatchDTO;
